module.exports = __webpack_public_path__ + "img/persia.176c962b.webp";